import { useState } from "react";
export function MailFormat({
  initial = "Plain text",
}: {
  initial?: string | undefined;
}) {
  const [format, setFormat] = useState(initial);
  return (
    <>
      <label>
        Message format
        <select
          name="bodyFormat"
          value={format}
          onChange={(event) => setFormat(event.target.value)}
        >
          <option>Plain text</option>
          <option>Formatted</option>
        </select>
      </label>
      {format === "Formatted" && (
        <p>
          Use **bold**, *italic*, and start a line with - for a bullet. HTML is
          treated as text.
        </p>
      )}
    </>
  );
}
